import { Section } from "../components/sections/TextSection";

export const ArrowConfig: Section = {
    row: 0,
    col: 0,
    name: 'Arrow',
    type: 'arrow',
    id: '44444',
    selected: false,
    height: 60,
    width: 60,
    rowCount: 10,
    colCount: 10,
    textContent: "",
    x: 0,
    y: 0,
    isLocked: false,
    propInfo: [
      {
        name: "Rotation",
        inputType: 'number',
        binding: 'parentElement.style.transform',
        value: 0,
        label: 'Rotation (degrees)',
      },
      {
        name: "direction",
        inputType: 'dropdown',
        options: [
          { label: 'Right', value: 'right' },
          { label: 'Left', value: 'left' },
          { label: 'Up', value: 'up' },
          { label: 'Down', value: 'down' }
        ],
        binding: 'dataset.direction',
        value: 'right',
        label: 'Arrow Direction',
      },
      {
        name: "strokeColor",
        inputType: 'color',
        binding: 'attributes.stroke.value',
        value: '#000000',
        label: 'Arrow Color',
      },
      {
        name: "strokeWidth",
        binding: 'attributes.stroke-width.value',
        inputType: 'number',
        value: '2', 
        label: 'Line Width',
      },
      {
        name: 'fillType',
        inputType: 'dropdown',
        options: [
          {label: 'Solid', value: '0,0'},
          {label: 'Dotted', value: '1,5'},
          {label: 'Dashed', value: '10,5'},
        ],
        binding: 'attributes.stroke-dasharray.value',
        value: '0,0',
        label: 'Line Style',
      }
    ]
  };